// import { UserClient } from "@/modules/auth/constant/client.user";
import { UserClient } from "@/modules/auth/constant/client.mock";
const Source = "/shop/upload";
const CONFIG = {
  headers: {
    "Content-Type": "multipart/form-data",
  },
};
export const uploadRepository = {
  sendFile(file) {
    return UserClient.post(Source, file, CONFIG);
  },
};
